// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"24d2952157c4812ff074","655":"1c4b81e7ffb4564fa9b7"}[chunkId] + ".js";
};